<template>
    <tr>
        <td>
            {{ station.name }}
        </td>
        <td>
            {{ station.code || '-'  }}
        </td>
        <td>
            {{ station.phone || '-' }}
        </td>
        <td style="
            max-width: 120px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        ">
            {{ station.note || '-' }}
        </td>
        <td>
            <router-link class="item" v-for="(child_station, index) in station.child_stations"
                :key="child_station.identity"
                :to="{
                    name: 'edit_station',
                    params: {
                        station_identity: child_station.identity
                    }
                }">
                {{ index + 1 }}. {{ child_station.name }}
                &nbsp;
            </router-link>
        </td>
        <td>
            <div class="" v-if="is_loading">
                <div class="ui basic loading green button">
                    {{ $t('ui.general.edit') }}
                </div>
                <a class="ui basic loading red button">
                    {{ $t('ui.general.delete') }}
                </a>
            </div>
            <div class="" v-else>
                <router-link :to="{name: 'edit_station', params: {station_identity: station.identity}}" class="ui basic green button">
                    {{ $t('ui.general.edit') }}
                </router-link>
                <a @click.prevent="$parent.delete_station(station)" class="ui basic red button">
                    {{ $t('ui.general.delete') }}
                </a>
            </div>
        </td>
    </tr>
</template>

<script>
export default {
    name: "ProviderStationsIndexItem",
    props: {
        station: Object
    },
    data() {
        return {
            is_loading: false,
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
    }
}
</script>
